import {PlanResource} from "models"
import {PlansSelectWithContainer} from "components/plans/select"
import React from "react"

export default {
  edit: {
    attributes: [
      {
        attribute: "planId",
        content: ({inputProps}) => (
          <PlansSelectWithContainer
            label={PlanResource.humanAttributeName("plan")}
            {...inputProps}
          />
        )
      },
      {attribute: "resourceName"}
    ]
  }
}
